<div class="app-content"><div class="intro-text">
  <p>{{'indoor_teams_intro' | transloco}}</p>
</div>
<div class="content-wrapper">
  <app-filters-series-teams></app-filters-series-teams>
  <app-indoor-world-series-list  class="app-team-ranking-list-indoor app-ranking"></app-indoor-world-series-list>
</div>
</div>
